(function (global) {
  'use strict';

  function selectedRows(rows) {
    return (rows || []).filter(function (row) {
      return row && row.selected && row.available && String(row.id || '').trim();
    });
  }

  function calculateSummary(rows) {
    var selected = selectedRows(rows);
    return {
      totalCents: selected.reduce(function (sum, row) {
        var price = Number(row.price);
        return sum + (Number.isFinite(price) && price >= 0 ? Math.round(price) : 0);
      }, 0),
      selectedCount: selected.length
    };
  }

  function calculateOffer(rows, discountCents, discountPercent) {
    var summary = calculateSummary(rows);
    var selected = selectedRows(rows);
    var main = selected.find(function (row) { return row.isMain; });
    var hasCompanion = main && selected.some(function (row) {
      return !row.isMain && String(row.id) !== String(main.id);
    });
    var requested = Number(discountCents);
    var rate = Number(discountPercent);
    var validPercent = Number.isFinite(rate) && rate > 0 && rate <= 100;
    var saving = summary.selectedCount >= 2 && validPercent
      ? Math.round(summary.totalCents * rate / 100)
      : hasCompanion && Number.isFinite(requested)
        ? Math.min(summary.totalCents, Math.max(0, Math.round(requested)))
        : 0;
    return {
      totalCents: summary.totalCents,
      finalCents: summary.totalCents - saving,
      discountCents: saving,
      selectedCount: summary.selectedCount
    };
  }

  function buildCartPayload(rows) {
    var main = (rows || []).find(function (row) { return row && row.isMain; });
    if (!main || !main.selected || !main.available || !String(main.id || '').trim()) {
      throw new Error('Select an available main product variant.');
    }
    var quantities = new Map();
    selectedRows(rows).forEach(function (row) {
      var id = String(row.id);
      quantities.set(id, (quantities.get(id) || 0) + 1);
    });
    return {
      items: Array.from(quantities, function (entry) {
        return { id: entry[0], quantity: entry[1] };
      })
    };
  }

  function cartUrl(root, action) {
    var safeRoot = typeof root === 'string' && /^\/[a-zA-Z0-9_/-]*$/.test(root) ? root : '/';
    if (safeRoot.charAt(safeRoot.length - 1) !== '/') safeRoot += '/';
    return safeRoot + (action === 'cart' ? 'cart' : 'cart/add.js');
  }

  function showCartAfterAdd(win, root, trigger) {
    var drawer = win.StitchCartDrawer;
    if (drawer && typeof drawer.open === 'function' && win.document &&
        win.document.getElementById('stitch-cart-drawer') &&
        win.document.getElementById('stitch-drawer-overlay')) {
      try {
        drawer.open(trigger);
        return;
      } catch (_) { /* Use the real cart page if the drawer cannot open. */ }
    }
    win.location.assign(cartUrl(root, 'cart'));
  }

  function updateCardImage(image, selectedUrl) {
    if (!image) return false;
    if (!Object.prototype.hasOwnProperty.call(image.dataset, 'hzclDefaultSrc')) {
      image.dataset.hzclDefaultSrc = image.getAttribute('src') || '';
      image.dataset.hzclDefaultSrcset = image.getAttribute('srcset') || '';
      image.dataset.hzclDefaultSizes = image.getAttribute('sizes') || '';
    }
    var target = selectedUrl || image.dataset.hzclDefaultSrc;
    if (!target) return false;
    if (image.getAttribute('src') !== target) image.setAttribute('src', target);
    if (selectedUrl) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
    } else {
      if (image.dataset.hzclDefaultSrcset) image.setAttribute('srcset', image.dataset.hzclDefaultSrcset);
      else image.removeAttribute('srcset');
      if (image.dataset.hzclDefaultSizes) image.setAttribute('sizes', image.dataset.hzclDefaultSizes);
      else image.removeAttribute('sizes');
    }
    return true;
  }

  function swatchHex(color) {
    var palette = {
      'siyah': '#222222', 'beyaz': '#ffffff', 'kırmızı': '#a52c3d',
      'saxs': '#2559a2', 'saks': '#2559a2', 'lila': '#a890c6',
      'fildişi': '#eee8d7', 'kahve': '#715142', 'taş': '#bcb2a5'
    };
    return palette[String(color || '').toLocaleLowerCase('tr-TR')] || '#ddd7df';
  }

  function updateVariantMedia(item, option) {
    if (!item || !option) return false;
    var image = item.querySelector('.hzcl__picture img');
    var placeholder = item.querySelector('[data-hzcl-image-placeholder]');
    var colorLabel = item.querySelector('[data-hzcl-selected-color]');
    var colorSwatch = item.querySelector('[data-hzcl-color-swatch]');
    var color = String(option.dataset.color || '').trim();
    var variantPhoto = String(option.dataset.photo || '').trim();
    var hasPhoto = !!variantPhoto;

    if (image) {
      if (hasPhoto) updateCardImage(image, variantPhoto);
      image.hidden = !hasPhoto;
    }
    if (placeholder) placeholder.hidden = hasPhoto;
    if (colorLabel) colorLabel.textContent = color;
    if (colorSwatch) {
      var palette = global.HanezzaColorPalette;
      if (palette && typeof palette.paint === 'function') {
        palette.paint(colorSwatch, color, {
          nativeColor: option.dataset.nativeColor,
          nativeImage: option.dataset.nativeImage,
          variantImage: option.dataset.photo
        });
      } else {
        colorSwatch.style.backgroundColor = swatchHex(color);
      }
    }
    return true;
  }

  function normalizeOutfitColor(value) {
    return String(value || '').trim().toLocaleLowerCase('tr-TR')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/ı/g, 'i').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  // Identify the base shade without treating "desenli", "çiçekli" or other
  // pattern descriptors as standalone colors. Never guess an unrelated shade.
  function canonicalOutfitColor(value) {
    var normalized = normalizeOutfitColor(value);
    if (!normalized) return '';
    if (/(^| )koyu mavi($| )/.test(normalized)) return 'lacivert';
    if (/(^| )fil disi($| )/.test(normalized)) return 'fildisi';
    var aliases = {
      'lacivert': 'lacivert', 'laci': 'lacivert', 'navy': 'lacivert',
      'marine': 'lacivert', 'marino': 'lacivert', 'dunkelblau': 'lacivert',
      'darkblue': 'lacivert', 'marinblau': 'lacivert',
      'siyah': 'siyah', 'black': 'siyah', 'schwarz': 'siyah', 'noir': 'siyah',
      'beyaz': 'beyaz', 'white': 'beyaz', 'blanc': 'beyaz',
      'kirmizi': 'kirmizi', 'red': 'kirmizi', 'rouge': 'kirmizi',
      'sax': 'saks', 'saks': 'saks', 'saxs': 'saks',
      'mavi': 'mavi', 'blue': 'mavi', 'indigo': 'indigo',
      'gri': 'gri', 'gray': 'gri', 'grey': 'gri', 'antrasit': 'antrasit',
      'bej': 'bej', 'beige': 'bej', 'ekru': 'ekru', 'krem': 'krem',
      'fildisi': 'fildisi', 'ivory': 'fildisi', 'tas': 'tas',
      'vizon': 'vizon', 'vizyon': 'vizon',
      'kahve': 'kahve', 'kahverengi': 'kahve', 'brown': 'kahve',
      'taba': 'taba', 'camel': 'camel', 'bordo': 'bordo',
      'yesil': 'yesil', 'green': 'yesil', 'haki': 'haki',
      'mor': 'mor', 'purple': 'mor', 'lila': 'lila',
      'pembe': 'pembe', 'pink': 'pembe', 'pudra': 'pudra',
      'sari': 'sari', 'yellow': 'sari', 'hardal': 'hardal',
      'turuncu': 'turuncu', 'orange': 'turuncu', 'kiremit': 'kiremit', 'kremit': 'kremit',
      'tarcin': 'tarcin', 'fusya': 'fusya', 'sarap': 'sarap',
      'petrol': 'petrol', 'turkuaz': 'turkuaz'
    };
    var words = normalized.split(' ');
    for (var i = 0; i < words.length; i++) {
      if (Object.prototype.hasOwnProperty.call(aliases, words[i])) return aliases[words[i]];
    }
    return '';
  }

  function findCompanionColorVariant(options, primaryColor, preferredSize) {
    var targetColor = canonicalOutfitColor(primaryColor);
    if (!targetColor) return null;
    var candidates = Array.from(options || []).filter(function (option) {
      return option && !option.disabled && option.dataset &&
        canonicalOutfitColor(option.dataset.color) === targetColor;
    });
    if (!candidates.length) return null;
    var size = String(preferredSize || '');
    return candidates.find(function (option) {
      return String(option.dataset.size || '') === size;
    }) || candidates[0];
  }

  // Rules only influence the initial suggested shade; they do not lock color or size.
  function shouldAutoSyncCompanion(hasManualColorChoice) {
    return !hasManualColorChoice;
  }

  function recommendCompanionVariant(options, sourceColor, rules, preferredSize, targetProductId, sourceSize) {
    var shade = canonicalOutfitColor(sourceColor);
    if (!shade) return null;
    var targetId = String(targetProductId || '').split('/').pop();
    var matchingRules = Array.isArray(rules) ? rules.filter(function (rule) {
      return rule && canonicalOutfitColor(rule.sourceColor) === shade &&
        String(rule.targetProductId || '').split('/').pop() === targetId;
    }) : [];
    var rule = matchingRules[0];
    if (!rule) {
      var legacy = findCompanionColorVariant(options, sourceColor, preferredSize);
      return legacy ? {
        variant: legacy,
        suggestedColor: sourceColor,
        appliedColor: String(legacy.dataset.color || ''),
        usedFallback: false,
        ruleFound: false
      } : null;
    }

    if (sourceSize) return chooseRuleVariant(options, rule, sourceSize, preferredSize, canonicalOutfitColor);
    var choices = [rule.targetColor].concat(Array.isArray(rule.alternativeColors) ? rule.alternativeColors : []);
    var visited = new Set();
    for (var i = 0; i < choices.length; i++) {
      var colorKey = canonicalOutfitColor(choices[i]);
      if (!colorKey || visited.has(colorKey)) continue;
      visited.add(colorKey);
      var match = findCompanionColorVariant(options, choices[i], preferredSize);
      if (match) return {
        variant: match,
        suggestedColor: String(rule.targetColor || ''),
        appliedColor: String(match.dataset.color || ''),
        usedFallback: i > 0,
        ruleFound: true
      };
    }
    return null;
  }

  function chooseVariantOption(options, color, size) {
    var available = Array.from(options || []).filter(function (option) {
      return option && !option.disabled;
    });
    var matching = available.filter(function (option) {
      return String(option.dataset.color || '') === String(color || '');
    });
    return matching.find(function (option) {
      return String(option.dataset.size || '') === String(size || '');
    }) || matching[0] || null;
  }

  // Show at most three colors on mobile. If a fourth/fifth color is chosen,
  // keep that chosen color visible in the last slot of the compact preview.
  // A shade stays visible if ANY of its sizes has a purchasable variant.
  // Unavailable variants remain in the native selector for size validation,
  // but they must not create crossed-out or phantom swatch buttons.
  function stockedOutfitColors(options) {
    return Array.from(new Set(Array.from(options || []).filter(function (option) {
      return option && !option.disabled && option.dataset &&
        String(option.dataset.color || '').trim();
    }).map(function (option) {
      return String(option.dataset.color).trim();
    })));
  }

  function compactColors(colors, currentColor, maxVisible) {
    var all = Array.from(colors || []);
    var max = Math.max(1, Number(maxVisible) || 3);
    var displayed = all.slice(0, max);
    if (displayed.length && all.includes(currentColor) && !displayed.includes(currentColor)) {
      displayed[displayed.length - 1] = currentColor;
    }
    return displayed;
  }

  function mountVariantPicker(item, locale) {
    var native = item.querySelector('[data-hzcl-variant]');
    var chooser = item.querySelector('[data-hzcl-chooser]');
    var swatches = item.querySelector('[data-hzcl-swatches]');
    var moreButton = item.querySelector('[data-hzcl-more-toggle]');
    var sizeSelect = item.querySelector('[data-hzcl-size]');
    var colorName = item.querySelector('[data-hzcl-color-name]');
    var nativeLabel = item.querySelector('[data-hzcl-native-label]');
    var optionName = String(item.dataset.hzclColorOption || '').toLocaleLowerCase('tr-TR');
    if (!['renk', 'color', 'colour', 'farbe', 'couleur', 'colore', 'لون', 'رنگ', 'цвет', 'χρώμα'].includes(optionName) ||
        !native || !chooser || !swatches || !sizeSelect || !colorName) return;

    var variants = Array.from(native.options);
    var available = variants.filter(function (option) {
      return !option.disabled && option.dataset.color && option.dataset.size;
    });
    if (!available.length) return;
    var isTr = /^tr\b/i.test(String(locale || ''));
    var colors = stockedOutfitColors(variants);
    var sizes = Array.from(new Set(variants.map(function (option) {
      return String(option.dataset.size || '');
    }).filter(Boolean)));
    if (!colors.length || !sizes.length) return;

    var extraColorCount = Math.max(0, colors.length - 3);
    var expanded = false;
    function updateCompactView() {
      var current = native.options[native.selectedIndex];
      var selectedColor = current ? String(current.dataset.color || '') : '';
      var preview = compactColors(colors, selectedColor, 3);
      swatches.dataset.hzclExpanded = String(expanded);
      swatches.querySelectorAll('[data-hzcl-color-choice]').forEach(function (button) {
        button.dataset.hzclOverflowColor = String(!preview.includes(button.dataset.hzclColorChoice));
      });
      if (moreButton && extraColorCount > 0) {
        moreButton.hidden = false;
        moreButton.textContent = expanded ? '−' : '+' + extraColorCount;
        moreButton.setAttribute('aria-expanded', String(expanded));
        moreButton.setAttribute('aria-label', expanded
          ? (isTr ? 'Daha az renk göster' : 'Show fewer colors')
          : (isTr ? extraColorCount + ' renk daha göster' : 'Show ' + extraColorCount + ' more colors'));
      }
    }
    if (moreButton && extraColorCount > 0) {
      moreButton.addEventListener('click', function () {
        expanded = !expanded;
        updateCompactView();
      });
    }

    colors.forEach(function (color) {
      var button = global.document.createElement('button');
      button.type = 'button';
      button.className = 'hzcl__swatch-btn';
      button.dataset.hzclColorChoice = color;
      button.setAttribute('data-hzcl-color-choice', color);
      button.setAttribute('aria-label', isTr ? color + ' rengini seç' : 'Choose ' + color);
      button.setAttribute('aria-pressed', 'false');
      button.title = color;
      var disc = global.document.createElement('span');
      disc.className = 'hzcl__swatch-core';
      var imageOption = variants.find(function (candidate) {
        return candidate.dataset.color === color && !candidate.disabled && candidate.dataset.photo;
      }) || variants.find(function (candidate) {
        return candidate.dataset.color === color && candidate.dataset.photo;
      }) || variants.find(function (candidate) {
        return candidate.dataset.color === color;
      });
      var palette = global.HanezzaColorPalette;
      if (palette && typeof palette.paint === 'function') {
        palette.paint(disc, color, {
          nativeColor: imageOption && imageOption.dataset.nativeColor,
          nativeImage: imageOption && imageOption.dataset.nativeImage,
          variantImage: imageOption && imageOption.dataset.photo
        });
      } else {
        disc.style.backgroundColor = swatchHex(color);
      }
      disc.setAttribute('aria-hidden', 'true');
      button.appendChild(disc);
      swatches.appendChild(button);
    });

    sizes.forEach(function (size) {
      var option = global.document.createElement('option');
      option.value = size;
      option.textContent = size;
      sizeSelect.appendChild(option);
    });

    function sync() {
      var current = native.options[native.selectedIndex];
      if (!current) return;
      var currentColor = String(current.dataset.color || '');
      var currentSize = String(current.dataset.size || '');
      colorName.textContent = currentColor;
      swatches.querySelectorAll('[data-hzcl-color-choice]').forEach(function (button) {
        var color = button.dataset.hzclColorChoice;
        var inStock = variants.some(function (option) {
          return !option.disabled && option.dataset.color === color;
        });
        button.disabled = !inStock;
        button.setAttribute('aria-pressed', String(color === currentColor));
        button.title = inStock ? color : color + (isTr ? ' · Tükendi' : ' · Sold out');
      });
      Array.from(sizeSelect.options).forEach(function (option) {
        option.disabled = !variants.some(function (variant) {
          return !variant.disabled && variant.dataset.color === currentColor &&
            variant.dataset.size === option.value;
        });
      });
      sizeSelect.value = currentSize;
      updateCompactView();
    }

    function selectChoice(choice) {
      if (!choice) return;
      native.value = choice.value;
      sync();
      native.dispatchEvent(new global.Event('change', { bubbles: true }));
    }

    swatches.addEventListener('click', function (event) {
      var button = event.target.closest('[data-hzcl-color-choice]');
      if (!button || button.disabled) return;
      var selected = native.options[native.selectedIndex];
      var preferredSize = selected ? selected.dataset.size : '';
      // A deliberate color swatch click wins over future automated suggestions.
      if (!item.hasAttribute('data-hzcl-main')) item.dataset.hzclManualColor = 'true';
      selectChoice(chooseVariantOption(variants, button.dataset.hzclColorChoice, preferredSize));
    });

    sizeSelect.addEventListener('change', function () {
      var selected = native.options[native.selectedIndex];
      if (!selected) return;
      var candidate = chooseVariantOption(variants, selected.dataset.color, sizeSelect.value);
      if (candidate && candidate.dataset.size === sizeSelect.value) selectChoice(candidate);
      else sync();
    });

    item.hzclSyncPicker = sync;
    sync();
    chooser.hidden = false;
    native.hidden = true;
    if (nativeLabel) nativeLabel.hidden = true;
  }

  function normalizedLabel(value) {
    return String(value || '').trim().toLocaleLowerCase('tr-TR');
  }

  function preferredPalette(sourceColor, rulesText) {
    var wanted = normalizedLabel(sourceColor);
    var row = String(rulesText || '').split(';').find(function (entry) {
      return normalizedLabel(entry.split(':')[0]) === wanted;
    });
    if (!row || !row.includes(':')) return [];
    return row.slice(row.indexOf(':') + 1).split(',').map(function (color) {
      return color.trim();
    }).filter(Boolean);
  }

  function sizeRangeIncludes(sourceSize, candidateSize) {
    var source = String(sourceSize || '').trim();
    var match = String(candidateSize || '').trim().match(/^(\d+)(?:\s*[-\u2013]\s*(\d+))?$/);
    if (!/^\d+$/.test(source) || !match) return false;
    var size = Number(source);
    return size >= Number(match[1]) && size <= Number(match[2] || match[1]);
  }

  function pickCompanionColorByFit(options, sourceColor, sourceSize, preferredSize, rulesText) {
    var colors = preferredPalette(sourceColor, rulesText);
    var optionsList = Array.from(options || []).filter(function (option) {
      return option && !option.disabled && option.dataset;
    });
    for (var i = 0; i < colors.length; i++) {
      var color = normalizedLabel(colors[i]);
      var matches = optionsList.filter(function (option) {
        return normalizedLabel(option.dataset.color) === color;
      });
      if (!matches.length) continue;
      var preserved = matches.find(function (option) {
        return String(option.dataset.size || '') === String(preferredSize || '');
      });
      return preserved || matches[0];
    }
    return null;
  }

  function pickSuggestedVariant(options, sourceColor, sourceSize, rulesText) {
    var desired = preferredPalette(sourceColor, rulesText);
    var available = Array.from(options || []).filter(function (option) {
      return option && !option.disabled && option.dataset;
    });
    for (var i = 0; i < desired.length; i++) {
      var color = desired[i];
      var found = available.find(function (option) {
        return normalizedLabel(option.dataset.color) === normalizedLabel(color);
      });
      if (found) return found;
    }
    return null;
  }

  function appendDraftCompanion(baseTargets, candidateId, eligible) {
    var out = Array.from(new Set(baseTargets || []));
    var id = String(candidateId || '');
    if (eligible && id && !out.includes(id) && out.length < 3) out.push(id);
    return out.slice(0, 3);
  }

  // V2 recommendations follow color and product; companion sizes stay independent.
  function sizeOverlaps(sourceSize, targetSize) {
    var parse = function (raw) {
      var match = String(raw || '').trim().match(/^(\d+)(?:\s*[-\u2013]\s*(\d+))?$/);
      if (!match) return null;
      var start = Number(match[1]);
      var end = Number(match[2] || match[1]);
      return start <= end ? [start, end] : null;
    };
    var source = parse(sourceSize);
    var target = parse(targetSize);
    if (!source || !target) {
      return String(sourceSize || '').trim() === String(targetSize || '').trim();
    }
    return source[0] <= target[1] && target[0] <= source[1];
  }

  function chooseRuleVariant(options, rule, sourceSize, preferredSize, normalizeColor) {
    if (!rule || typeof normalizeColor !== 'function') return null;
    var shades = [rule.targetColor].concat(Array.isArray(rule.alternativeColors) ? rule.alternativeColors : []);
    var visited = new Set();
    for (var i = 0; i < shades.length; i++) {
      var shade = normalizeColor(shades[i]);
      if (!shade || visited.has(shade)) continue;
      visited.add(shade);
      var matches = Array.from(options || []).filter(function (option) {
        return option && !option.disabled && option.dataset &&
          normalizeColor(option.dataset.color) === shade;
      });
      if (!matches.length) continue;
      var best = matches.find(function (option) {
        return String(option.dataset.size || '') === String(preferredSize || '');
      }) || matches[0];
      return {
        variant: best,
        suggestedColor: String(rule.targetColor || ''),
        appliedColor: String(best.dataset.color || ''),
        usedFallback: i > 0,
        ruleFound: true
      };
    }
    return null;
  }

  function eligibleTargets(sourceColor, rules, availableIds, defaultTargetId, normalizeColor, sourceSize, variantOptionsById) {
    var shade = normalizeColor(sourceColor);
    var ids = new Set(Array.from(availableIds || []).map(function (id) { return String(id || '').split('/').pop(); }));
    var matched = (Array.isArray(rules) ? rules : []).filter(function (rule) {
      return rule && normalizeColor(rule.sourceColor) === shade;
    });
    var targets = [];
    matched.forEach(function (rule) {
      if (targets.length >= 3) return;
      var id = String(rule.targetProductId || '').split('/').pop();
      if (!ids.has(id) || targets.includes(id)) return;
      if (variantOptionsById &&
          !chooseRuleVariant(variantOptionsById[id], rule, sourceSize, '', normalizeColor)) return;
      targets.push(id);
    });
    // An unavailable V2 color never silently falls back to an unrelated product.
    if (matched.length) return targets;
    var fallback = String(defaultTargetId || '').split('/').pop();
    if (!ids.has(fallback)) return [];
    if (variantOptionsById &&
        !Array.from(variantOptionsById[fallback] || []).some(function (option) {
          return option && !option.disabled && option.dataset;
        })) return [];
    return [fallback];
  }

  function chooseCompanionTargetId(sourceColor, rules, availableTargetIds, defaultTargetId) {
    var shade = canonicalOutfitColor(sourceColor);
    var ids = Array.from(availableTargetIds || []).map(function (id) { return String(id || '').split('/').pop(); });
    var fallback = String(defaultTargetId || '').split('/').pop();
    var matched = Array.isArray(rules) ? rules.find(function (rule) {
      return rule && canonicalOutfitColor(rule.sourceColor) === shade;
    }) : null;
    var requested = matched ? String(matched.targetProductId || '').split('/').pop() : fallback;
    return ids.indexOf(requested) !== -1 ? requested : null;
  }

  function isActiveOutfitItem(item) { return !!item && !item.hidden; }

  function inspectRows(widget) {
    return Array.from(widget.querySelectorAll('[data-hzcl-item]'), function (item) {
      var selector = item.querySelector('[data-hzcl-variant]');
      var option = selector && selector.options[selector.selectedIndex];
      var toggle = item.querySelector('[data-hzcl-toggle]');
      return {
        id: option ? option.value : '',
        price: option ? Number(option.dataset.price) : 0,
        available: !!option && !option.disabled,
        selected: toggle ? (toggle.checked && isActiveOutfitItem(item)) : isActiveOutfitItem(item),
        isMain: item.hasAttribute('data-hzcl-main')
      };
    });
  }

  function soldOutCombinationNotice(unavailable, locale) {
    if (!unavailable) return '';
    return /^tr\b/i.test(String(locale || ''))
      ? 'Seçtiğiniz renk ve beden stokta yok. Lütfen stoklu bir beden veya renk seçin.'
      : 'This color and size is sold out. Please choose an available color or size.';
  }

  // Move the existing shuffle control with the active mobile companion card.
  // Desktop keeps the control in the section heading; no duplicate buttons.
  function placeMobileShuffle(widget, companion, tools, button, activeElement) {
    if (!widget.classList.contains('hzcl--mobile') || !companion || !tools || tools.parentElement === companion) return false;
    var picker = companion.querySelector('[data-hzcl-chooser]');
    if (!picker) return false;
    var wasFocused = activeElement === button;
    companion.insertBefore(tools, picker);
    if (wasFocused && button && typeof button.focus === 'function') button.focus({ preventScroll: true });
    return true;
  }

  function mount(widget) {
    if (widget.dataset.hzclMounted === 'true') return;
    widget.dataset.hzclMounted = 'true';
    var totalNode = widget.querySelector('[data-hzcl-total]');
    var originalNode = widget.querySelector('[data-hzcl-original]');
    var savingsNode = widget.querySelector('[data-hzcl-savings]');
    var countNode = widget.querySelector('[data-hzcl-count]');
    var button = widget.querySelector('[data-hzcl-add]');
    var shuffleTools = widget.querySelector('[data-hzcl-shuffle-tools]');
    var shuffleButton = widget.querySelector('[data-hzcl-shuffle]');
    var shuffleCount = widget.querySelector('[data-hzcl-shuffle-count]');
    var feedback = widget.querySelector('[data-hzcl-feedback]');
    var priceNodes = widget.querySelectorAll('[data-hzcl-current-price]');
    if (!totalNode || !countNode || !button || !feedback) return;
    var currency = widget.dataset.currency || 'TRY';
    var locale = widget.dataset.locale || 'tr-TR';
    var formatter;
    try { formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }); }
    catch (_) { formatter = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }); }

    function update() {
      var rows = inspectRows(widget);
      var summary = calculateSummary(rows);
      var offer = calculateOffer(rows, 0, widget.dataset.hzclPreviewDiscountPercent);
      var mainReady = rows.some(function (row) { return row.isMain && row.available && row.selected; });
      totalNode.textContent = formatter.format(offer.finalCents / 100);
      if (originalNode) {
        originalNode.hidden = !offer.discountCents;
        originalNode.textContent = offer.discountCents ? formatter.format(offer.totalCents / 100) : '';
      }
      if (savingsNode) {
        savingsNode.hidden = !offer.discountCents;
        var percent = offer.totalCents ? Math.round(100 * offer.discountCents / offer.totalCents) : 0;
        savingsNode.textContent = offer.discountCents ? '-' + formatter.format(offer.discountCents / 100) + ' (%' + percent + ')' : '';
      }
      countNode.textContent = String(summary.selectedCount);
      button.disabled = !mainReady || summary.selectedCount < 2 || widget.dataset.hzclBusy === 'true';
      var stockNote = widget.querySelector('[data-hzcl-main-stock-notice]');
      if (stockNote) {
        var currentMain = rows.find(function (row) { return row.isMain; });
        var availabilityText = soldOutCombinationNotice(!!currentMain && !currentMain.available, locale);
        stockNote.hidden = !availabilityText;
        stockNote.textContent = availabilityText;
      }
      priceNodes.forEach(function (el) {
        var item = el.closest('[data-hzcl-item]');
        var selector = item && item.querySelector('[data-hzcl-variant]');
        var option = selector && selector.options[selector.selectedIndex];
        if (option) {
          el.textContent = formatter.format(Number(option.dataset.price) / 100);
          updateVariantMedia(item, option);
          if (typeof item.hzclSyncPicker === 'function') item.hzclSyncPicker();
        }
      });
      if (feedback.dataset.hzclError === 'true') {
        feedback.textContent = '';
        feedback.dataset.hzclError = 'false';
      }
    }

    var mainProductItem = widget.querySelector('[data-hzcl-item][data-hzcl-main]');
    var companionItems = Array.from(widget.querySelectorAll('[data-hzcl-item]')).filter(function (item) {
      return !item.hasAttribute('data-hzcl-main');
    });
    var companionItem = companionItems[0] || null;
    var defaultTargetId = companionItem && companionItem.dataset.hzclProductId;
    var lastMatchedMainColor = '';
    var lastMatchedMainSize = '';
    var shuffleIndex = 0;
    var ruleList = [];
    try {
      var parsedRules = JSON.parse(widget.dataset.hzclColorRules || '[]');
      if (Array.isArray(parsedRules)) ruleList = parsedRules;
    } catch (_) { /* Unparseable metadata does not prevent legacy selection. */ }

    function currentShuffleChoices(sourceColor, sourceSize) {
      var variantOptions = {};
      var stockedIds = companionItems.filter(function (item) {
        var select = item.querySelector('[data-hzcl-variant]');
        if (!select) return false;
        variantOptions[item.dataset.hzclProductId] = Array.from(select.options);
        return variantOptions[item.dataset.hzclProductId].some(function (option) { return !option.disabled; });
      }).map(function (item) { return item.dataset.hzclProductId; });
      var choices = eligibleTargets(sourceColor, ruleList, stockedIds, defaultTargetId,
        canonicalOutfitColor, sourceSize, variantOptions);
      var pilot = companionItems.find(function (item) { return item.hasAttribute('data-hzcl-shuffle-pilot'); });
      var pilotSelect = pilot && pilot.querySelector('[data-hzcl-variant]');
      var matching = pilotSelect && pickSuggestedVariant(
        pilotSelect.options, sourceColor, sourceSize, widget.dataset.hzclPilotPalette
      );
      return appendDraftCompanion(choices, pilot && pilot.dataset.hzclProductId, !!matching);
    }

    function syncResetControl() {
      companionItems.forEach(function (item) {
        var reset = item.querySelector('[data-hzcl-reset-color]');
        if (reset) reset.hidden = item.dataset.hzclManualColor !== 'true';
      });
    }

    function synchronizeCompanionColor(force) {
      if (!mainProductItem || !companionItems.length) return false;
      var mainSelect = mainProductItem.querySelector('[data-hzcl-variant]');
      if (!mainSelect) return false;
      var selectedMain = mainSelect.options[mainSelect.selectedIndex];
      if (!selectedMain || selectedMain.disabled) return false;
      var mainColorKey = canonicalOutfitColor(selectedMain.dataset.color);
      var mainSizeKey = String(selectedMain.dataset.size || '');
      if (!mainColorKey) return false;
      if (lastMatchedMainColor && mainColorKey !== lastMatchedMainColor) shuffleIndex = 0;
      var targets = currentShuffleChoices(selectedMain.dataset.color, selectedMain.dataset.size);
      if (shuffleIndex >= targets.length) shuffleIndex = 0;
      var targetId = targets[shuffleIndex] || null;
      if (shuffleTools && shuffleCount) {
        shuffleTools.hidden = targets.length < 2;
        shuffleCount.textContent = targets.length > 1 ? (shuffleIndex + 1) + ' / ' + targets.length : '';
      }
      var targetItem = companionItems.find(function (item) {
        return item.dataset.hzclProductId === targetId;
      }) || null;
      var changedProduct = targetItem !== companionItem;
      companionItems.forEach(function (item) { item.hidden = item !== targetItem; });
      companionItem = targetItem;
      if (!companionItem) { update(); return false; }
      companionItem.hidden = false;
      placeMobileShuffle(widget, companionItem, shuffleTools, shuffleButton, global.document && global.document.activeElement);
      var companionSelect = companionItem.querySelector('[data-hzcl-variant]');
      if (!companionSelect) return false;
      var selectedCompanion = companionSelect.options[companionSelect.selectedIndex];
      if (companionItem.hasAttribute('data-hzcl-shuffle-pilot')) {
        lastMatchedMainColor = mainColorKey;
        lastMatchedMainSize = mainSizeKey;
        var recommended = pickSuggestedVariant(companionSelect.options, selectedMain.dataset.color,
          selectedMain.dataset.size, widget.dataset.hzclPilotPalette);
        if (!recommended) {
          var unavailableToggle = companionItem.querySelector('[data-hzcl-toggle]');
          if (unavailableToggle) unavailableToggle.checked = false;
          update();
          return false;
        }
        if (companionItem.dataset.hzclManualColor === 'true' &&
            selectedCompanion && !selectedCompanion.disabled) {
          update();
          return false;
        }
        if (recommended.value !== companionSelect.value) {
          companionSelect.value = recommended.value;
          companionSelect.dispatchEvent(new global.Event('change', { bubbles: true }));
        } else {
          update();
        }
        return true;
      }
      if (!force && !changedProduct && mainColorKey === lastMatchedMainColor && mainSizeKey === lastMatchedMainSize) return false;
      lastMatchedMainColor = mainColorKey;
      lastMatchedMainSize = mainSizeKey;
      if (!shouldAutoSyncCompanion(companionItem.dataset.hzclManualColor === 'true')) {
        update();
        return false;
      }
      var preferredSize = selectedCompanion ? selectedCompanion.dataset.size : '';
      var recommendation = recommendCompanionVariant(
        companionSelect.options, selectedMain.dataset.color, ruleList,
        preferredSize, companionItem.dataset.hzclProductId, mainSizeKey
      );
      if (!recommendation && companionItem === companionItems[0] && widget.dataset.hzclPilotPalette) {
        var matchedCompanion = pickCompanionColorByFit(
          companionSelect.options, selectedMain.dataset.color, selectedMain.dataset.size,
          preferredSize, widget.dataset.hzclPilotPalette
        );
        if (matchedCompanion) {
          recommendation = {
            variant: matchedCompanion,
            suggestedColor: String(matchedCompanion.dataset.color || ''),
            appliedColor: String(matchedCompanion.dataset.color || ''),
            usedFallback: false,
            ruleFound: false
          };
        }
      }
      var colorNotice = companionItem.querySelector('[data-hzcl-color-notice]');
      if (!recommendation) {
        var hasExactRule = ruleList.some(function (rule) {
          return canonicalOutfitColor(rule.sourceColor) === mainColorKey &&
            String(rule.targetProductId || '').split('/').pop() === companionItem.dataset.hzclProductId;
        });
        if (hasExactRule) {
          companionItem.dataset.hzclNoMatch = 'true';
          var toggle = companionItem.querySelector('[data-hzcl-toggle]');
          if (toggle && toggle.checked) {
            toggle.checked = false;
            companionItem.dataset.hzclAutoUnchecked = 'true';
          }
          if (colorNotice) {
            colorNotice.textContent = /^tr\\b/i.test(locale)
              ? 'Bu renk için stoklu, uyumlu bir kombin önerisi bulunamadı. Dilerseniz diğer renkleri inceleyin.'
              : 'No compatible in-stock recommended color. You can explore other colors.';
          }
          update();
        }
        return false;
      }
      companionItem.dataset.hzclNoMatch = 'false';
      if (companionItem.dataset.hzclAutoUnchecked === 'true') {
        var companionToggle = companionItem.querySelector('[data-hzcl-toggle]');
        if (companionToggle) companionToggle.checked = true;
        companionItem.dataset.hzclAutoUnchecked = 'false';
      }
      if (colorNotice) {
        colorNotice.textContent = recommendation.usedFallback
          ? (/^tr\\b/i.test(locale)
            ? 'Önerilen ' + recommendation.suggestedColor + ' rengi stokta yok. ' + recommendation.appliedColor + ' gösteriliyor.'
            : 'Suggested ' + recommendation.suggestedColor + ' is unavailable. Showing ' + recommendation.appliedColor + '.')
          : '';
      }
      if (recommendation.variant.value === companionSelect.value) {
        update();
        return false;
      }
      companionSelect.value = recommendation.variant.value;
      companionSelect.dispatchEvent(new global.Event('change', { bubbles: true }));
      return true;
    }

    widget.addEventListener('click', function (event) {
      var shuffle = event.target.closest && event.target.closest('[data-hzcl-shuffle]');
      if (shuffle && shuffleButton && !shuffleButton.disabled) {
        var selectedMain = mainProductItem && mainProductItem.querySelector('[data-hzcl-variant]');
        var option = selectedMain && selectedMain.options[selectedMain.selectedIndex];
        var choices = option && !option.disabled ? currentShuffleChoices(option.dataset.color, option.dataset.size) : [];
        if (choices.length < 2) return;
        shuffleIndex = (shuffleIndex + 1) % choices.length;
        synchronizeCompanionColor(true);
        syncResetControl();
        update();
        return;
      }
      var reset = event.target.closest && event.target.closest('[data-hzcl-reset-color]');
      if (!reset || !companionItem || !companionItem.contains(reset)) return;
      companionItem.dataset.hzclManualColor = 'false';
      lastMatchedMainColor = '';
      synchronizeCompanionColor(true);
      syncResetControl();
      update();
    });

    widget.addEventListener('change', function (event) {
      if (mainProductItem && event.target && mainProductItem.contains(event.target) &&
          event.target.matches('[data-hzcl-variant]')) {
        synchronizeCompanionColor();
      }
      if (companionItem && event.target && companionItem.contains(event.target) &&
          event.target.matches('[data-hzcl-variant]') && event.isTrusted) {
        companionItem.dataset.hzclManualColor = 'true';
      }
      syncResetControl();
      update();
    });
    widget.querySelectorAll('[data-hzcl-item]').forEach(function (item) {
      mountVariantPicker(item, widget.dataset.locale);
    });
    button.addEventListener('click', async function () {
      if (button.disabled) return;
      var rows = inspectRows(widget);
      var summary = calculateSummary(rows);
      if (summary.selectedCount < 2) return;
      var payload;
      try { payload = buildCartPayload(rows); }
      catch (_) {
        feedback.textContent = widget.dataset.chooseVariantError || 'Please select a size.';
        feedback.dataset.hzclError = 'true';
        return;
      }
      widget.dataset.hzclBusy = 'true';
      button.disabled = true;
      feedback.textContent = widget.dataset.loadingText || 'Adding to cart…';
      var root = global.Shopify && global.Shopify.routes && global.Shopify.routes.root;
      try {
        var response = await global.fetch(cartUrl(root, 'add'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error('Cart request failed');
        widget.dataset.hzclBusy = 'false';
        update();
        feedback.textContent = '';
        showCartAfterAdd(global, root, button);
      } catch (_) {
        widget.dataset.hzclBusy = 'false';
        update();
        feedback.textContent = widget.dataset.cartError || 'Products could not be added. Please try again.';
        feedback.dataset.hzclError = 'true';
      }
    });
    synchronizeCompanionColor();
    syncResetControl();
    update();
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { placeMobileShuffle: placeMobileShuffle, soldOutCombinationNotice: soldOutCombinationNotice, sizeOverlaps: sizeOverlaps, chooseRuleVariant: chooseRuleVariant, sizeRangeIncludes: sizeRangeIncludes, pickCompanionColorByFit: pickCompanionColorByFit, normalizedLabel: normalizedLabel, preferredPalette: preferredPalette, pickSuggestedVariant: pickSuggestedVariant, appendDraftCompanion: appendDraftCompanion, eligibleTargets: eligibleTargets, chooseCompanionTargetId: chooseCompanionTargetId, isActiveOutfitItem: isActiveOutfitItem, calculateSummary: calculateSummary, calculateOffer: calculateOffer, buildCartPayload: buildCartPayload, cartUrl: cartUrl, showCartAfterAdd: showCartAfterAdd, updateCardImage: updateCardImage, updateVariantMedia: updateVariantMedia, chooseVariantOption: chooseVariantOption, compactColors: compactColors, stockedOutfitColors: stockedOutfitColors, canonicalOutfitColor: canonicalOutfitColor, findCompanionColorVariant: findCompanionColorVariant, recommendCompanionVariant: recommendCompanionVariant, shouldAutoSyncCompanion: shouldAutoSyncCompanion };
  }
  if (typeof document !== 'undefined') {
    var boot = function () {
      document.querySelectorAll('[data-hzcl-root]').forEach(mount);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  }
})(typeof window !== 'undefined' ? window : globalThis);
